@import '../../shared/frame';

chapel-video {
  position: absolute;
  inset: 0;
  min-height: calc(100vw / (560 / 315));
}

 .overlay {
   @include smooth-gradient(black, 'to top');
 }

.indicator {
  background: red;
  padding: 2vw 2vw 0.5vw;
  line-height: 8vw !important;
  letter-spacing: 0.05rem !important;
  font-size: 8vw !important;
}

.brand {
  font-size: 10vw !important;
}

.qr {
  width: 20vw;
}

.logo {
  width: 10vw;
}
